export const DASHBOARD_TIPS: string[] = [
  `The cutoff for remittances is 9pm on week days. Remittances uploaded on a weekend will be
  processed the following monday.`,
  `Always double check the amount you remit.`,
  `In case of errors, you may request your remittances to be editted.`
];